import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import WordInsideReqListArea from "@/pages/comp_stu/plan/word_inside/common/req_list";

function WordInsideReqList() {

  return (
    <CompLayout>
      <WordInsideReqListArea></WordInsideReqListArea>
    </CompLayout>
  );
}

export default WordInsideReqList;